if (!customElements.get('worth-buy-now')) {
  customElements.define(
    'worth-buy-now',
    class WorthBuyNow extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-worth-buy-now-form]');
        this.button = this.querySelector('.worth-buy-now-button');
        this.section = this.closest('[id^="MainProduct-"]');

        if (!this.form || !this.section) return;

        this.syncAvailability();
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
        this.section.addEventListener('change', () => {
          window.setTimeout(() => this.syncAvailability(), 0);
        });

        const primaryButton = this.getPrimaryButton();
        if (primaryButton) {
          this.observer = new MutationObserver(() => this.syncAvailability());
          this.observer.observe(primaryButton, {
            attributes: true,
            attributeFilter: ['disabled'],
          });
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      getPrimaryButton() {
        return this.section.querySelector('.product-form__submit');
      }

      syncAvailability() {
        const primaryButton = this.getPrimaryButton();
        if (primaryButton && this.button) {
          this.button.disabled = primaryButton.disabled;
        }
      }

      handleSubmit(event) {
        const primaryButton = this.getPrimaryButton();
        if (primaryButton && primaryButton.disabled) {
          event.preventDefault();
          return;
        }

        const productForm = this.section.querySelector('product-form form');
        const activeVariant = productForm?.querySelector('input[name="id"]');
        const quantityInput = this.section.querySelector(
          'quantity-input input[name="quantity"], input.quantity__input[name="quantity"]'
        );
        const variantField = this.form.querySelector('[data-worth-buy-now-variant]');
        const quantityField = this.form.querySelector('[data-worth-buy-now-quantity]');

        if (activeVariant && variantField) variantField.value = activeVariant.value;
        if (quantityInput && quantityField) quantityField.value = quantityInput.value;
      }
    }
  );
}
